export const PhoneContactIcon = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_468_4782)">
                <path
                    d="M14.2511 5.5321C15.074 5.59051 17.8398 13.23 17.7814 14.0529C17.6645 15.6986 15.0791 17.1691 14.1394 18.7564C13.1997 20.3438 14.7286 22.1063 16.2575 23.8689C16.8538 24.5563 19.3154 27.394 21.0195 26.688C22.7237 25.9819 24.5446 23.6301 26.1904 23.747C27.0133 23.8054 34.1854 27.6226 34.127 28.4454C33.8934 31.7369 31.2495 34.0303 28.7225 34.6779C26.1955 35.3255 24.5497 35.2087 21.3167 34.1522C18.0836 33.0957 15.6734 32.0976 11.8511 27.6912C8.02885 23.2848 7.38122 20.7577 6.792 17.4078C6.20277 14.058 6.3196 12.4122 7.3177 10.002C8.31581 7.59183 10.9597 5.29845 14.2511 5.5321Z"
                    stroke="url(#paint0_linear_468_4782)" strokeWidth="3" strokeLinecap="round"
                    strokeLinejoin="round"/>
            </g>
            <defs>
                <linearGradient id="paint0_linear_468_4782" x1="24.4547" y1="-9.8035" x2="59.3074" y2="54.1832"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <clipPath id="clip0_468_4782">
                    <rect width="33.3333" height="33.3333" fill="white" transform="translate(3.33337 3.33325)"/>
                </clipPath>
            </defs>
        </svg>
    );
};